'use client';

import LinksList from './links-list';
import useCategoryStore from '@/store/category.store';
import { handleFooterWithCategories } from '@/utils/global';

const LinksListSection = ({
  linksList,
  // isLast = false,
  isMobile,
  // forceAll = false,
  asAccordion = false,
}) => {
  const menuTreeData = useCategoryStore((state) => state.footerCT);

  // categories explicitly included in footer
  const footerCategories = menuTreeData?.filter(
    (item) => item?.include_in_footer
  );

  const transformCategoryToLink = (category) => ({
    'title-ar': category?.name,
    'title-en': category?.name,
    value: category?.children_data?.map((child) => ({
      'title-ar': child?.name,
      'title-en': child?.name,
      url: `/c/${child?.innova_url}`,
    })),
    active: true,
    'mobile-active': true,
  });

  const combinedLinks = footerCategories?.length
    ? handleFooterWithCategories([
        ...footerCategories?.map(transformCategoryToLink),
        ...(linksList?.value || []),
      ])
    : linksList?.value || [];

  return (
    <>
      {combinedLinks?.map((category, index) => (
        <LinksList
          key={index}
          category={category}
          isMobile={isMobile}
          asAccordion={asAccordion}
        />
      ))}
    </>
  );
};

export default LinksListSection;
